import _slicedToArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { polarToCartesian, assembleLocString } from '@jbrowse/core/util';
import { thetaRangesOverlap } from './viewportVisibleRegion';
export var Slice = /*#__PURE__*/function () {
  function Slice(view, region, offsetRadians, radianWidth) {
    _classCallCheck(this, Slice);
    this.region = region;
    this.offsetRadians = offsetRadians;
    this.radianWidth = radianWidth;
    var bpPerRadian = view.bpPerRadian;
    this.key = 'regions' in region ? JSON.stringify(region.regions) : assembleLocString(region);
    this.bpPerRadian = bpPerRadian;
    this.flipped = false;
    this.startRadians = offsetRadians;
    this.endRadians = region.widthBp / this.bpPerRadian + offsetRadians;
    Object.freeze(this);
  }
  _createClass(Slice, [{
    key: "bpToXY",
    value: function bpToXY(bp, radiusPx) {
      var offsetBp;
      if (this.region.elided) {
        offsetBp = this.region.widthBp / 2;
      } else if (this.flipped) {
        offsetBp = this.region.end - bp;
      } else {
        offsetBp = bp - this.region.start;
      }
      var totalRadians = offsetBp / this.bpPerRadian + this.offsetRadians;
      return polarToCartesian(radiusPx, totalRadians);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return Object.fromEntries(Object.entries(this));
    }
  }]);
  return Slice;
}();
function calculateStaticSlices(self) {
  var slices = [];
  var currentRadianOffset = 0;
  var bpPerRadian = self.bpPerRadian,
    spacingPx = self.spacingPx,
    pxPerRadian = self.pxPerRadian;
  var _iterator = _createForOfIteratorHelper(self.elidedRegions),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var region = _step.value;
      var radianWidth = region.widthBp / bpPerRadian + spacingPx / pxPerRadian;
      slices.push(new Slice(self, region, currentRadianOffset, radianWidth));
      currentRadianOffset += radianWidth;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return slices;
}
function sliceIsVisible(self, slice) {
  var _self$visibleSection$ = _slicedToArray(self.visibleSection.theta, 2),
    visibleThetaMin = _self$visibleSection$[0],
    visibleThetaMax = _self$visibleSection$[1];
  return thetaRangesOverlap(slice.offsetRadians + self.offsetRadians, slice.radianWidth, visibleThetaMin, visibleThetaMax - visibleThetaMin);
}
export { calculateStaticSlices, sliceIsVisible };